import React from 'react'
import { AppGlobalContext } from '../provider'

export const useGlobalState = () => {
  const allStates = React.useContext(AppGlobalContext)
  return allStates
}
